<div class="detailsCard__titleText">{{ title }}</div>
<div class="detailsCard__title">{{ description }}</div>
